import React, {useContext, useState} from "react"
import Row from "@amzn/meridian/row";
import {FormattedMessage} from "react-intl";
import ButtonGroup, {ButtonOption} from "@amzn/meridian/button-group"
import {StageFilterContext} from "./context/StageFilterContext";
import {DEFAULT_CAPABILITIES, PLAN_MANAGEMENT_VIEW, ROUTE_VIEW} from "../util/Constants";
import {CapabilityContext} from "../global/context/CapabilityContext";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";

const StageTabViewSelector = () => {
    const [stageTabView, setStageTabView] = useState(ROUTE_VIEW);
    const {dispatchF} = useContext(StageFilterContext)
    const {configViewModel} = useContext(CapabilityContext)
    const {spacingInset_shorthand4} = useDeviceLayout()

    const toggleView = (newValue) => {
        setStageTabView(newValue);
        dispatchF({type: 'SELECT_STAGE_TAB_VIEW_TYPE', stageTabViewType: newValue})
    };

    return (
        <div>
            {DEFAULT_CAPABILITIES.includes(configViewModel.capability) &&
            (configViewModel.stationConfig.stagenabled)  ?
                <Row spacingInset={spacingInset_shorthand4}>
                    <ButtonGroup value={stageTabView} onChange={toggleView}>
                        <ButtonOption value={ROUTE_VIEW}>
                            <FormattedMessage id="stageOverall.routeView" defaultMessage="Route View"/>
                        </ButtonOption>
                        <ButtonOption value={PLAN_MANAGEMENT_VIEW}>
                            <FormattedMessage id="stageOverall.planManagementView" defaultMessage={"Plan Management View"} />
                        </ButtonOption>
                    </ButtonGroup>
                </Row>
                : null
            }
        </div>
    )
}

export default StageTabViewSelector



// WEBPACK FOOTER //
// ./src/components/stageStatus/StageTabViewSelector.js